const initialState = "active"; // "under_maintenance" | "active" 
  
  const siteStatusReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_MAINTENANCE_ON':
        return "under_maintenance";
  
      case 'SET_MAINTENANCE_OFF':
        return "active";
  
      default:
        return state;
    }
  };
  
  export default siteStatusReducer;
  